module.exports = __webpack_public_path__ + "static/media/full_stack_image.42233cf7.jpg";